import * as types from '../constants/ActionTypes';

const initialState = {
  faqId: undefined,
};

export default function (state = initialState, action) {
  switch (action.type) {
    case types.RECEIVE_FAQID:
      return Object.assign({}, state, { faqId: action.payload });
    case types.NO_FAQID:
      return Object.assign({}, state, { faqId: undefined });
    default:
      return state;
  }
}
